// extracted by mini-css-extract-plugin
export var cell = "_6z-4";
export var headerCell = "_6z-2";
export var rowHeader = "_6z-3";
export var table = "_6z-1";
export var tableContainer = "_6z-0";